/**
* description:
* File of container Recharges Container
*
* data : 2017-08-03
*/

import Vue from 'vue';
import store from '@/store';
import { mapGetters } from 'vuex';

// COMPONENTS //////////////////////////////////////////////////////////////////
import RechargesHistoryDetails from '@/components/Recharges/RechargesHistoryDetails';
import RechargesHistorySearchTerms from '@/components/Recharges/RechargesHistorySearchTerms';
import RechargesHistorySummary from '@/components/Recharges/RechargesHistorySummary';

// CONTAINER ///////////////////////////////////////////////////////////////////
const Recharges = {
  components: {
    RechargesHistoryDetails,
    RechargesHistorySearchTerms,
    RechargesHistorySummary,
  },
  store,
  computed: {
    ...mapGetters(['subscriber', 'rechargesList', 'pendingStoreActions']),
  },
  template: `
    <div class="container-fluid animated fadeIn">
      <div class="row">
        <div class="col-xs-12 col-md-7">
          <recharges-history-summary :subscriber="subscriber" :recharges-list="rechargesList" 
            :is-loading-data="pendingStoreActions.includes('getRechargesList')" />
        </div>
        <div class="col-xs-12 col-md-5">
          <recharges-history-search-terms :recharges-list="rechargesList" 
            :is-loading-data="pendingStoreActions.includes('getRechargesList')" />
        </div>
        <div class="col-xs-12">
          <recharges-history-details :recharges-list="rechargesList" 
            :is-loading-data="pendingStoreActions.includes('getRechargesList')" />
        </div>        
      </div>
    </div>
  `,
};

export default Vue
  .component('Recharges', Recharges);



// WEBPACK FOOTER //
// ./src/containers/Recharges/index.js